module.exports = __webpack_public_path__ + "static/media/Card.165a3c12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Card.png
// module id = 2067
// module chunks = 0